import React from "react";
import PropTypes from "prop-types";
import { AppContext } from "../context/AppContext";
import DatePickerContainer from './DatePickerContainer';
import { Input, NumericTextBox } from '@progress/kendo-react-inputs';
import { Button } from "@progress/kendo-react-buttons";
import DropDownContainer from "./DropDownContainer";
import { isEmpty, queryStringBuilder, parseDateString, getRoleID } from "../helpers";
import isPage from '../hoc/isPage';
import config from '../config/config';
import moment from 'moment';
import localize from "../hoc/localize";
import { IntlProvider, load } from "@progress/kendo-react-intl";
import currencyData from "cldr-core/supplemental/currencyData.json";
import frNumbers from "cldr-numbers-full/main/fr/numbers.json";
import frCurrencies from "cldr-numbers-full/main/fr/currencies.json";
load(currencyData, frNumbers, frCurrencies);

class ValueFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool,
        mode: PropTypes.string,
    }

    componentDidMount = () => {
        if (this.props.mode === "min") {
            this.props.handleChange({
                target: {
                    name: "selectedReportMaxValue", value: null
                }
            });
        }
        else if (this.props.mode === "max") {
            this.props.handleChange({
                target: {
                    name: "selectedReportMinValue", value: null
                }
            });
        }
    }

    render() {

        //!DBTRANS! @m0614@ Minimum Value: !DEVNOTE! Dropdown label
        //!DBTRANS! @m0615@ Maximum Value: !DEVNOTE! Dropdown label
        //!DBTRANS! @m0616@ Max Value cannot be less than Min Value! !DEVNOTE! Error message
        return (
            <IntlProvider locale={this.props.uiLanguage}>
                <div>
                    {(this.props.mode === "min" || this.props.mode === "both") && <div className="k-form-field bottom-margin-10">
                        <label htmlFor="selectedReportMinValue">{this.props.returnLocalizedString("m0614")}</label>{" "}
                        <NumericTextBox
                            style={{ textAlign: "right" }}
                            id="selectedReportMinValue"
                            value={this.context.state.selectedReportMinValue ? this.context.state.selectedReportMinValue : 0}
                            required={this.props.required === true}
                            name="selectedReportMinValue"
                            type="numeric"
                            onChange={this.props.handleChange}
                            format={{ style: "currency", currency: "USD" }}
                        />
                    </div>}
                    {(this.props.mode === "max" || this.props.mode === "both") && <div className="k-form-field bottom-margin-10">
                        <label htmlFor="selectedReportMaxValue">{this.props.returnLocalizedString("m0615")}</label>{" "}
                        <NumericTextBox
                            style={{ textAlign: "right" }}
                            id="selectedReportMaxValue"
                            value={this.context.state.selectedReportMaxValue ? this.context.state.selectedReportMaxValue : 0}
                            required={this.props.required === true}
                            name="selectedReportMaxValue"
                            type="numeric"
                            onChange={this.props.handleChange}
                            format={{ style: "currency", currency: "USD" }}
                        />
                    </div>}
                </div>
            </IntlProvider>
        );
    }
}
const ValueFilterLocalized = localize(ValueFilter);

class AgeFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool,
    }

    render() {
        //!DBTRANS! @m0611@ Age (months): !DEVNOTE! Error message
        return (
            <div>
                <div className="k-form-field bottom-margin-10">
                    <label htmlFor="selectedReportAge">{this.props.returnLocalizedString("m0611")}</label>{" "}
                    <NumericTextBox
                        id="selectedReportAge"
                        value={this.context.state.selectedReportAge ? this.context.state.selectedReportAge : 0}
                        required={this.props.required === true}
                        name="selectedReportAge"
                        defaultValue={12}
                        type="numeric"
                        onChange={this.props.handleChange}
                        format={"i"}
                        min={0}
                        step={1}
                    />
                </div>
            </div>
        );
    }
}

const AgeFilterLocalized = localize(AgeFilter);

class CostFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool,
        mode: PropTypes.string,
    }

    componentDidMount = () => {
        if (this.props.mode === "min") {
            this.props.handleChange({
                target: {
                    name: "selectedReportMaxCost", value: null
                }
            });
        }
        else if (this.props.mode === "max") {
            this.props.handleChange({
                target: {
                    name: "selectedReportMinCost", value: null
                }
            });
        }
    }

    render() {

        //!DBTRANS! @m0608@ Minimum Cost: !DEVNOTE! Dropdown label
        //!DBTRANS! @m0609@ Maximum Cost: !DEVNOTE! Dropdown label
        //!DBTRANS! @m0610@ Max Cost cannot be less than Min Cost! !DEVNOTE! Error message
        return (
            <IntlProvider locale={this.props.uiLanguage}>
                <div>
                    {(this.props.mode === "min" || this.props.mode === "both") && <div className="k-form-field bottom-margin-10">
                        <label htmlFor="selectedReportMinCost">{this.props.returnLocalizedString("m0608")}</label>{" "}
                        <NumericTextBox
                            id="selectedReportMinCost"
                            value={this.context.state.selectedReportMinCost ? this.context.state.selectedReportMinCost : 0}
                            required={this.props.required === true}
                            name="selectedReportMinCost"
                            type="numeric"
                            onChange={this.props.handleChange}
                            format={{ style: "currency", currency: "USD" }}
                        />
                    </div>}
                    {(this.props.mode === "max" || this.props.mode === "both") && <div className="k-form-field bottom-margin-10">
                        <label htmlFor="selectedReportMaxCost">{this.props.returnLocalizedString("m0609")}</label>{" "}
                        <NumericTextBox
                            id="selectedReportMaxCost"
                            value={this.context.state.selectedReportMaxCost ? this.context.state.selectedReportMaxCost : 0}
                            required={this.props.required === true}
                            name="selectedReportMaxCost"
                            type="numeric"
                            onChange={this.props.handleChange}
                            format={{ style: "currency", currency: "USD" }}
                        />
                    </div>}
                </div>
            </IntlProvider>
        );
    }
}
const CostFilterLocalized = localize(CostFilter);

class PartCategoryFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool,
    }

    componentDidMount = () => {
        this.props.handleChange({
            target: {
                name: "selectedReportPartCategory", value: {
                    partCategoryName:
                        this.props.returnLocalizedString("m0606"),
                    partCategoryID: ""
                }
            },
        });
    }

    render() {

        let hasEmptyOption = this.props.hasEmptyOption;
        if (hasEmptyOption !== false) {
            hasEmptyOption = true;
        }
        return (
            <div className="k-form-field bottom-margin-10">

                <label htmlFor="selectedReportPartCategory">{this.props.returnLocalizedString("m0607")}</label>{" "}
                <DropDownContainer
                    id="selectedReportPartCategory"
                    value={this.context.state.selectedReportPartCategory}
                    required={this.props.required === true}
                    name="selectedReportPartCategory"
                    mode="combobox"
                    dataType="partCategories"
                    uiLanguage={this.props.getLanguage()}
                    handleChange={this.props.handleChange}
                />
            </div>
        );
    }
}
const PartCategoryFilterLocalized = localize(PartCategoryFilter);

class PartGroupFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool,
        hasEmptyOption: PropTypes.bool
    }

    componentDidMount = () => {
        this.props.handleChange({
            target: {
                name: "selectedReportPartGroup", value: {
                    partGroupName:
                        this.props.returnLocalizedString("m0438"),
                    partGroupID: ""
                }
            },
        });
    }

    render() {

        let hasEmptyOption = this.props.hasEmptyOption;
        if (hasEmptyOption !== false) {
            hasEmptyOption = true;
        }
        return (
            <div className="k-form-field bottom-margin-10">

                <label htmlFor="selectedReportPartGroup">{this.props.returnLocalizedString("m0475")}</label>{" "}
                <DropDownContainer
                    id="selectedReportPartGroup"
                    value={this.context.state.selectedReportPartGroup}
                    hasEmptyOption={this.props.hasEmptyOption !== false}
                    defaultToFirstItem={this.props.hasEmptyOption !== false ? true : false}
                    required={this.props.required === true}
                    name="selectedReportPartGroup"
                    dataType="partGroups"
                    uiLanguage={this.props.getLanguage()}
                    handleChange={this.props.handleChange}
                />
            </div>
        );
    }
}
const PartGroupFilterLocalized = localize(PartGroupFilter);

class OrderTypeFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool
    }
    render() {
        return (
            <div className="k-form-field bottom-margin-10">

                <label htmlFor="selectedOrderType">{this.props.returnLocalizedString("m0475")}</label>{" "}
                <DropDownContainer
                    id="selectedOrderType"
                    value={this.context.state.selectedOrderType}
                    required={this.props.required === true}
                    name="selectedOrderType"
                    dataType="orderTypes"
                    uiLanguage={this.props.getLanguage()}
                    handleChange={this.props.handleChange}
                />
            </div>
        );
    }
}
const OrderTypeFilterLocalized = localize(OrderTypeFilter);

class PartNumberFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool
    }
    render() {
        return (
            <div className="k-form-field bottom-margin-10">

                <label htmlFor="selectedPartNumber">{this.props.returnLocalizedString("m0143")}</label>{" "}
                <Input
                    id="selectedPartNumber"
                    value={this.context.state.selectedPartNumber ? this.context.state.selectedPartNumber : ""}
                    required={this.props.required === true}
                    name="selectedPartNumber"
                    type="text"
                    onChange={this.props.handleChange}
                />
            </div>
        );
    }
}
const PartNumberFilterLocalized = localize(PartNumberFilter);

class ExceptionFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool
    }
    render() {
        return (
            <div className="k-form-field bottom-margin-10">

                <label htmlFor="selectedException">{this.props.returnLocalizedString("m0470")}</label>{" "}
                <DropDownContainer
                    id="selectedException"
                    value={this.context.state.selectedException}
                    required={this.props.required === true}
                    name="selectedException"
                    dataType="exceptions"
                    uiLanguage={this.props.getLanguage()}
                    handleChange={this.props.handleChange}
                />
            </div>
        );
    }
}
const ExceptionFilterLocalized = localize(ExceptionFilter);

class CountryFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool
    }
    render() {
        return (
            <div className="k-form-field bottom-margin-10">

                <label htmlFor="selectedCountry">{this.props.returnLocalizedString("m0471")}</label>{" "}
                <DropDownContainer
                    id="selectedCountry"
                    value={this.context.state.selectedCountry}
                    required={this.props.required === true}
                    name="selectedCountry"
                    dataType="countries"
                    uiLanguage={this.props.getLanguage()}
                    handleChange={this.props.handleChange}
                />
            </div>
        );
    }
}
const CountryFilterLocalized = localize(CountryFilter);

class OrgTypeFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool
    }
    render() {
        return (
            <div className="k-form-field bottom-margin-10">

                <label htmlFor="selectedOrgType">{this.props.returnLocalizedString("m0472")}</label>{" "}
                <DropDownContainer
                    id="selectedOrgType"
                    value={this.context.state.selectedOrgType}
                    required={this.props.required === true}
                    name="selectedOrgType"
                    dataType="orgTypes"
                    uiLanguage={this.props.getLanguage()}
                    handleChange={this.props.handleChange}
                />
            </div>
        );
    }
}
const OrgTypeFilterLocalized = localize(OrgTypeFilter);


class OrgFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool
    }
    render() {
        //this.state.country.countryID
        return (
            <AppContext.Consumer>
                {(context) => (
                    <div className="k-form-field bottom-margin-10">

                        <label htmlFor="selectedOrg">{this.props.returnLocalizedString("m0473")}</label>{" "}
                        <DropDownContainer
                            id="selectedOrg"
                            value={this.context.state.selectedOrg}
                            required={this.props.required === true}
                            name="selectedOrg"
                            dataType="allOrgs"
                            countryID={context.state.selectedCountry ? context.state.selectedCountry.countryID : null}
                            orgTypeID={context.state.selectedOrgType ? context.state.selectedOrgType.orgTypeID : null}
                            uiLanguage={this.props.getLanguage()}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                )}
            </AppContext.Consumer>
        );
    }
}
const OrgFilterLocalized = localize(OrgFilter);

class MonthYearFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool
    }
    render() {
        return (
            <div className="k-form-field">

                <label htmlFor="selectedMonthYear">{this.props.returnLocalizedString("m0474")}</label>{" "}
                <DropDownContainer
                    id="selectedMonthYear"
                    value={this.context.state.selectedMonthYear}
                    required={this.props.required === true}
                    hasEmptyOption={this.props.hasEmptyOption !== false}
                    label={this.props.hasEmptyOption !== false ? null : this.props.returnLocalizedString("m0020")}
                    name="selectedMonthYear"
                    dataType="monthYears"
                    uiLanguage={this.props.getLanguage()}
                    handleChange={this.props.handleChange}
                />
            </div>
        );
    }
}
const MonthYearFilterLocalized = localize(MonthYearFilter);

class VendorFilter extends React.Component {
    _error;
    static propTypes = {
        required: PropTypes.bool,
        hasEmptyOption: PropTypes.bool,
        majorVendor: PropTypes.bool,
        dealerGroupOnly: PropTypes.bool,
        handleChange: PropTypes.func
    };
    render() {

        let required = this.props.required;
        if (required !== true) {
            required = false;
        }
        let hasEmptyOption = this.props.hasEmptyOption;
        if (hasEmptyOption !== false) {
            hasEmptyOption = true;
        }

        const orgType = this.context.state.orgType;

        if (orgType === "dealergroup")
            // need to pass in defaultValue={this.context.state.selectedReportVendor}
            return (
                <AppContext.Consumer>
                    {(context) => (

                        <div className="k-form-field bottom-margin-10">

                            <label htmlFor="selectedReportVendor">{this.props.returnLocalizedString("m0038")}</label>{" "}

                            <DropDownContainer
                                id="selectedReportVendor"
                                value={context.state.selectedReportVendor}
                                required={this.props.required === true}
                                hasEmptyOption={this.props.hasEmptyOption !== false}
                                label={this.props.hasEmptyOption !== false ? null : this.props.returnLocalizedString("m0019")}
                                defaultToFirstItem={this.props.hasEmptyOption !== false ? true : false}
                                name="selectedReportVendor"
                                dataType={this.props.majorVendor ? "majorVendors" : "vendors"}
                                uiLanguage={this.props.getLanguage()}
                                handleChange={this.props.handleChange}
                                orgID={this.props.dealerGroupOnly === true ? 0 :
                                    (context.state.selectedReportOrg ?
                                        context.state.selectedReportOrg.orgID :
                                        undefined)
                                }
                            />
                        </div>

                    )}
                </AppContext.Consumer>
            );
        else
            // need to pass in defaultValue={this.context.state.selectedReportVendor}
            return (
                <AppContext.Consumer>
                    {(context) => (

                        <div className="k-form-field bottom-margin-10">

                            <label htmlFor="selectedReportVendor">{this.props.returnLocalizedString("m0038")}</label>{" "}

                            <DropDownContainer
                                id="selectedReportVendor"
                                value={context.state.selectedReportVendor}
                                required={this.props.required === true}
                                hasEmptyOption={this.props.hasEmptyOption !== false}
                                label={this.props.hasEmptyOption !== false ? null : this.props.returnLocalizedString("m0019")}
                                defaultToFirstItem={this.props.hasEmptyOption !== false ? true : false}
                                name="selectedReportVendor"
                                dataType={this.props.majorVendor ? "majorVendors" : "vendors"}
                                uiLanguage={this.props.getLanguage()}
                                handleChange={this.props.handleChange}
                            />
                        </div>

                    )}
                </AppContext.Consumer>
            );
    }
}
const VendorFilterLocalized = localize(VendorFilter);

class DealershipFilter extends React.Component {
    static propTypes = {
        required: PropTypes.bool,
        hasEmptyOption: PropTypes.bool,
        filterType: PropTypes.oneOf(['dealership', 'reportGroup', 'both']),
        handleChange: PropTypes.func
    };

    handleFilterChange = e => {

        this.props.handleChange(e);
    };


    render() {

        let hasEmptyOption = this.props.hasEmptyOption;
        if (hasEmptyOption !== false) {
            hasEmptyOption = true;
        }

        return (
            <AppContext.Consumer>
                {(context) => (
                    <div data-filtertype={this.props.filterType} className="dealership-filter">
                        <div className="k-form-field">
                            {this.props.filterType === "both" && (
                                <React.Fragment>

                                    <span>

                                        <input
                                            type="radio"
                                            checked={
                                                context.state.selectedReportOrgType ===
                                                "dealership"
                                            }
                                            id="dealership"
                                            name="selectedReportOrgType"
                                            className="k-radio"
                                            onChange={this.handleFilterChange}
                                            value="dealership"
                                        />
                                        <label
                                            htmlFor="dealership"
                                            className="k-radio-label"
                                        >
                                            {this.props.returnLocalizedString("m0476")}
                                        </label>
                                        <br />

                                        <input
                                            type="radio"
                                            checked={
                                                context.state.selectedReportOrgType ===
                                                "reportGroup"
                                            }
                                            id="reportGroup"
                                            name="selectedReportOrgType"
                                            className="k-radio"
                                            onChange={this.handleFilterChange}
                                            value="reportGroup"
                                        />

                                        <label
                                            htmlFor="reportGroup"
                                            className="k-radio-label"
                                        >
                                            {this.props.returnLocalizedString("m0477")}
                                        </label>
                                    </span>


                                </React.Fragment>
                            )}

                            {this.props.filterType === "dealership" && (
                                <label htmlFor="selectedReportOrg">{this.props.returnLocalizedString("m0476")}</label>
                            )}
                            {this.props.filterType === "reportGroup" && (
                                <label htmlFor="selectedReportReportGroup">{this.props.returnLocalizedString("m0477")}</label>
                            )}

                            {
                                // if the filter shows only dealerships, OR
                                // the filter offers both dealership and reportgroup options but dealership is chosen, THEN
                                // show the dealership dropdown
                                (this.props.filterType === "dealership" || (this.props.filterType === "both" && context.state.selectedReportOrgType === "dealership")) && (

                                    <DropDownContainer
                                        id="selectedReportOrg"
                                        name="selectedReportOrg"
                                        dataType="dealerships"
                                        required={this.props.required === true}
                                        hasEmptyOption={this.props.hasEmptyOption !== false}
                                        label={this.props.hasEmptyOption !== false ? null : this.props.returnLocalizedString("m0478")}
                                        defaultToFirstItem={this.props.hasEmptyOption !== false ? true : false}
                                        //style={{ height: '30.4375px' }}
                                        value={context.state.selectedReportOrg}
                                        uiLanguage={this.props.getLanguage()}
                                        handleChange={this.props.handleChange}
                                    />
                                )}

                            {
                                // if the filter shows only report groups, OR
                                // the filter offers both dealership and reportgroup options but reportgroup is chosen, THEN
                                // show the dealership dropdown
                                (this.props.filterType === "reportGroup" || (this.props.filterType === "both" && context.state.selectedReportOrgType === "reportGroup")) && (

                                    <DropDownContainer
                                        id="selectedReportReportGroup"
                                        name="selectedReportReportGroup"
                                        dataType="reportGroups"
                                        required={this.props.required === true}
                                        value={context.state.selectedReportReportGroup}
                                        uiLanguage={this.props.getLanguage()}
                                        handleChange={this.props.handleChange}
                                    />
                                )}
                        </div>
                    </div>

                )}
            </AppContext.Consumer>
        );
    }
}
const DealershipFilterLocalized = localize(DealershipFilter);

class DateFilter extends React.Component {
    _error;
    static propTypes = {
        required: PropTypes.bool,

        startDate: PropTypes.string,
        endDate: PropTypes.string,
        handleClearDate: PropTypes.func.isRequired,
        handleChange: PropTypes.func
    };

    render() {
        const startDate = parseDateString(this.context.state.selectedReportStartDate);
        const endDate = parseDateString(this.context.state.selectedReportEndDate);

        return (

            <div className="date-filter">

                <span className="k-form-field">
                    <label htmlFor="startDate">{this.props.returnLocalizedString("m0479")}</label>{" "}
                    <DatePickerContainer
                        id="startDate"
                        value={startDate}
                        required={true}
                        label={this.props.returnLocalizedString("m0481")}
                        name="selectedReportStartDate"
                        onChange={this.props.handleChange}
                        handleClearDate={this.props.handleClearDate}
                    />
                </span>
                <span className="k-form-field">
                    <label htmlFor="endDate">{this.props.returnLocalizedString("m0480")}</label>{" "}
                    <DatePickerContainer
                        id="endDate"
                        value={endDate}
                        label={this.props.returnLocalizedString("m0482")}
                        name="selectedReportEndDate"
                        onChange={this.props.handleChange}
                        handleClearDate={this.props.handleClearDate}
                    />
                </span>
            </div>

        );
    }
}
const DateFilterLocalized = localize(DateFilter);
;
// builds data filters based on the org type and chosen report

// upon form submission, it will build an API URL with all the filter values attached to it, then pass it back to the parent, so the parent can call the API

class ReportsDataFilters extends React.Component {
    static propTypes = {
        reportType: PropTypes.string,
        reportTitle: PropTypes.string,
        callApi: PropTypes.func,
        getFilterValues: PropTypes.func,
        disabled: PropTypes.bool,
        disabledSettings: PropTypes.element,
        role: PropTypes.shape({
            roleID: PropTypes.string,
            role: PropTypes.string  // name of role
        }),

        // what mode is the page operating in?
        // options:
        //      reports (normalReports)
        //      admin >> admin reports (adminReports)
        mode: PropTypes.oneOf([
            "normalReports",
            "adminReports",
            "bookingReports"
        ])
    }

    state = {
        filterControls: null
    }
    //constructor(props) {
    //    super(props);

    //}
    componentDidMount() {
        this.getFilterFields();
    }

    // handles changes to any of the filtering mechanisms
    handleChange = e => {
        //console.log(e.target.name)
        this.context.setState({
            [e.target.name]: e.target.value
        });
    };

    // handle clearing out the datepicker
    handleClearDate = fieldName => {

        this.context.setState({
            [fieldName]: null
        });
        this.forceUpdate();
    }

    // validate the user's inputs
    validateFilterValues = () => {

        let error = "";
        // // let's figure out what validation we need to do

        let dealershipFilterType = ""; // both, dealership, or reportGroup

        //!DBTRANS! @m0612@ You must select the part category filter! !DEVNOTE! Error message
        //!DBTRANS! @m0613@ You must select the age filter! !DEVNOTE! Error message

        !isEmpty(this.state.filterControls) && this.state.filterControls.forEach(value => {

            switch (value.type.displayName.toLowerCase()) {
                case "valuefilter":
                    if (this.context.state.selectedReportMinValue !== null && this.context.state.selectedReportMaxValue !== null) {
                        if (this.context.state.selectedReportMaxValue < this.context.state.selectedReportMinValue) {
                            error = "m0616"
                        }
                    }
                    break;
                case "agefilter":
                    if (value.props.required && isEmpty(this.context.state.selectedReportAge)) {
                        error = "m0613";
                    }
                    break;
                case "partcategoryfilter":
                    if (value.props.required && isEmpty(this.context.state.selectedReportPartCategory)) {
                        error = "m0612";
                    }
                    break;
                case "partgroupfilter":
                    if (value.props.required && isEmpty(this.context.state.selectedReportPartGroup)) {
                        error = "m0483";
                    }
                    break;
                case "ordertypefilter":
                    if (value.props.required && isEmpty(this.context.state.selectedOrderType)) {
                        error = "m0484";
                    }
                    break;
                case "partnumberfilter":
                    if (value.props.required && isEmpty(this.context.state.selectedPartNumber)) {
                        error = "m0485";
                    }
                    break;
                case "exceptionfilter":
                    if (value.props.required && isEmpty(this.context.state.selectedException)) {
                        error = "m0486";
                    }
                    break;
                case "countryfilter":
                    if (value.props.required && isEmpty(this.context.state.selectedCountry)) {
                        error = "m0487";
                    }
                    break;
                case "orgtypefilter":
                    if (value.props.required && isEmpty(this.context.state.selectedOrgType)) {
                        error = "m0488";
                    }
                    break;
                case "orgfilter":
                    if (value.props.required && isEmpty(this.context.state.selectedOrg)) {
                        error = "m0489";
                    }
                    break;
                case "monthyearfilter":
                    if (value.props.required && isEmpty(this.context.state.selectedMonthYear)) {
                        error = "m0490";
                    }
                    break;
                case "datefilter":
                    if (isEmpty(this.context.state.selectedReportStartDate)) {
                        error = "m0491";
                    } else if (
                        !isEmpty(this.context.state.selectedReportEndDate) &&
                        moment(this.context.state.selectedReportStartDate) >
                        moment(this.context.state.selectedReportEndDate)
                    ) {
                        error = "m0492";
                    }
                    break;
                case "vendorfilter":
                    if (value.props.required)
                        if (isEmpty(this.context.state.selectedReportVendor) || (this.context.state.selectedReportVendor.orgVendorID === "")) {
                            error = "m0493";
                        }

                    break;
                case "dealershipfilter":
                    // get the type of filter: possible values - "both", "dealership", "reportGroup"
                    dealershipFilterType = value.props.filterType;

                    //let selectedOrgType = "";

                    // if field is required, then check these error conditions:

                    // if filter type = "both" and no org type selected
                    // if filter type = "dealership" and no dealership selected, OR filter type = "both" and org type = "dealership" and no dealership has been selected)
                    // if filter type = "reportGroup" and no report group selected, OR filter type = "both" and org type = "reportGroup" and no report group has been selected
                    if (value.props.required) {
                        if (
                            dealershipFilterType === "both" &&
                            isEmpty(this.context.state.selectedReportOrgType)
                        ) {
                            error =
                                "m0494";
                        } else if (
                            (dealershipFilterType === "dealership" &&
                                isEmpty(
                                    this.context.state.selectedReportOrg
                                )) ||
                            (dealershipFilterType === "both" &&
                                this.context.state.selectedReportOrgType ===
                                "dealership" &&
                                isEmpty(this.context.state.selectedReportOrg))
                        ) {
                            error = "m0495";
                        } else if (
                            (dealershipFilterType === "reportGroup" &&
                                isEmpty(
                                    this.context.state.selectedReportReportGroup
                                )) ||
                            (dealershipFilterType === "both" &&
                                this.context.state.selectedReportOrgType ===
                                "reportGroup" &&
                                isEmpty(
                                    this.context.state.selectedReportReportGroup
                                ))
                        ) {
                            error = "m0496";
                        }
                    }

                    break;
                case "costfilter":
                    if (this.context.state.selectedReportMinCost !== null && this.context.state.selectedReportMaxCost !== null) {
                        if (this.context.state.selectedReportMaxCost < this.context.state.selectedReportMinCost) {
                            error = "m0610"
                        }
                    }
                    break;
                default:
                    break;
            }

        });

        if (!isEmpty(error)) {
            this.props.errorAlert(error);
            return false;
        }
        return true;
    }

    // handles the submission of the search criteria, and RUNS THE REPORT
    applyFilter = (e) => {

        e.preventDefault();


        // validate the filters
        if (!this.validateFilterValues()) {
            return;
        }

        // check the selected filter type
        let dealershipFilterType = ''; // the selected type
        let dealershipFilter; // the component

        // this.state.filterControls is a Set object, so "find" won't work
        !isEmpty(this.state.filterControls) && this.state.filterControls.forEach(control => {
            if (control.type.displayName.toLowerCase() === "dealershipfilter") {
                dealershipFilter = control;
            }
        })

        // find the filter type; could be "dealership","reportGroup", or "both"
        if (dealershipFilter) {
            dealershipFilterType = dealershipFilter.props.filterType;
        }

        // get rid of all spaces in report title
        //let reportTitle = this.props.reportTitle.replace(/\s/g, "");

        // build the querystring containing chosen report filters
        let builder = new queryStringBuilder();

        // grab the filter values out of the context

        const orgID = this.context.state.selectedReportOrg
            ? this.context.state.selectedReportOrg.orgID
            : null;

        const orgType = this.context.state.selectedReportOrgType;

        const partCategoryID = this.context.state.selectedReportPartCategory
            ? this.context.state.selectedReportPartCategory.partCategoryID
            : null;

        const partGroupID = this.context.state.selectedReportPartGroup
            ? this.context.state.selectedReportPartGroup.partGroupID
            : null;

        const orderTypeID = this.context.state.selectedOrderType
            ? this.context.state.selectedOrderType.orderTypeID
            : null;

        const partNumber = this.context.state.selectedPartNumber;

        const exceptionID = this.context.state.selectedException
            ? this.context.state.selectedException.exceptionID
            : null;

        const countryID = this.context.state.selectedCountry
            ? this.context.state.selectedCountry.countryID
            : null;

        const orgTypeID = this.context.state.selectedOrgType
            ? this.context.state.selectedOrgType.orgTypeID
            : null;

        const orgID2 = this.context.state.selectedOrg
            ? this.context.state.selectedOrg.orgID
            : null;

        const monthYear = this.context.state.selectedMonthYear
            ? this.context.state.selectedMonthYear.dateID
            : null;

        const reportGroupID = this.context.state.selectedReportReportGroup
            ? this.context.state.selectedReportReportGroup.reportGroupID
            : null;


        const selectedReportVendor = this.context.state.selectedReportVendor;
        let orgVendorID;
        let vendorID;
        if (selectedReportVendor) {
            if (selectedReportVendor.hasOwnProperty("vendorID")) {
                // from DropDownContainer with dataType majorVendors or adminVendors
                vendorID = selectedReportVendor.vendorID;
            }
            if (selectedReportVendor.hasOwnProperty("orgVendorID")) {
                // from DropDownContainer with dataType vendors
                if (orgID === 0) {
                    // the logged on user is a dealer group user, the orgVendorID is actually vendorID
                    vendorID = selectedReportVendor.orgVendorID;
                }
                else {
                    orgVendorID = selectedReportVendor.orgVendorID;
                }
            }
        }

        const startDate = this.context.state.selectedReportStartDate
            ? moment(this.context.state.selectedReportStartDate).format(
                "YYYYMMDD"
            )
            : null;

        const endDate = this.context.state.selectedReportEndDate
            ? moment(this.context.state.selectedReportEndDate).format(
                "YYYYMMDD"
            )
            : null;

        const minCost = this.context.state.selectedReportMinCost;
        const maxCost = this.context.state.selectedReportMaxCost;

        const age = this.context.state.selectedReportAge;

        const minValue = this.context.state.selectedReportMinValue;
        const maxValue = this.context.state.selectedReportMaxValue;

        // construct the querystring based on the report filters that are present
        !isEmpty(this.state.filterControls) && this.state.filterControls.forEach(control => {
            //console.log(control.type.displayName.toLowerCase())
            switch (control.type.displayName.toLowerCase()) {

                case "agefilter":
                    //console.log(age)
                    if (!isEmpty(age)) {
                        builder.append("age", age);
                    }
                    break;
                case "partcategoryfilter":
                    //console.log(partCategoryID)
                    if (!isEmpty(partCategoryID)) {
                        builder.append("partCategoryID", partCategoryID);
                    }
                    break;
                case "partgroupfilter":
                    if (!isEmpty(partGroupID)) {
                        builder.append("partGroup", partGroupID);
                    }
                    break;
                case "ordertypefilter":
                    if (!isEmpty(orderTypeID)) {
                        builder.append("orderType", orderTypeID);
                    }
                    break;
                case "partnumberfilter":
                    if (!isEmpty(partNumber)) {
                        builder.append("partNumber", partNumber);
                    }
                    break;
                case "exceptionfilter":
                    if (!isEmpty(exceptionID)) {
                        builder.append("exception", exceptionID);
                    }
                    break;
                case "countryfilter":
                    if (!isEmpty(countryID)) {
                        builder.append("countryID", countryID);
                    }
                    break;
                case "orgtypefilter":
                    if (!isEmpty(orgTypeID)) {
                        builder.append("orgTypeID", orgTypeID);
                    }
                    break;
                case "orgfilter":
                    if (!isEmpty(orgID2)) {
                        builder.append("orgID", orgID2);
                    }
                    break;
                case "monthyearfilter":
                    if (!isEmpty(monthYear)) {
                        builder.append("monthYear", monthYear);
                    }
                    break;
                case "dealershipfilter":
                    // if it's a dealership filter type, and user chose an actual dealership, then add the dealership ID to the querystring
                    if (dealershipFilterType === "dealership" && !isEmpty(orgID)) {
                        builder.append("orgID", orgID);
                    }
                    // if it's a reportgroup filter type, and user chose an actual report group, then add the report group ID to the querystring 
                    if (
                        dealershipFilterType === "reportGroup" &&
                        !isEmpty(reportGroupID)
                    ) {
                        builder.append("reportGroupID", reportGroupID);
                    }

                    if (dealershipFilterType === "both" && !isEmpty(orgType)) {
                        if (orgType === "dealership" && !isEmpty(orgID)) {
                            builder.append("orgID", orgID);
                        } else if (orgType === "reportGroup" && !isEmpty(reportGroupID)) {
                            builder.append("reportGroupID", reportGroupID);
                        }
                    }
                    break;
                case "vendorfilter":
                    if (!isEmpty(orgVendorID)) {
                        builder.append("orgVendorID", orgVendorID);
                    }
                    if (!isEmpty(vendorID)) {
                        builder.append("vendorID", vendorID);
                    }
                    break;
                case "datefilter":
                    if (!isEmpty(startDate)) {
                        builder.append("startDate", startDate);
                    }
                    if (!isEmpty(endDate)) {
                        builder.append("endDate", endDate);
                    }
                    break;
                case "costfilter":
                    if (minCost !== null) {
                        builder.append("minCost", minCost)
                    }
                    if (maxCost !== null) {
                        builder.append("maxCost", maxCost)
                    }
                    break;
                case "valuefilter":
                    if (minValue !== null) {
                        builder.append("minValue", minValue)
                    }
                    if (maxValue !== null) {
                        builder.append("maxValue", maxValue)
                    }
                    break;
                default:
                    break;
            }

        });

        this.props.getFilterValues({ orderType: orderTypeID, monthYear: monthYear });

        // all report API endpoints look like this: /api/portal/report/${endpointSlug}
        // or /api/portal/report/slowmovingitems?autoFilterType=${endpointSlug}&
        let endpointSlug = this.props.reportType.replace(/-/g, '');
        let apiUrl;
        switch (this.props.mode) {
            case "bookingReports":
                builder.append("orgID", orgID)
                apiUrl = "/api/portal/report/";
                break;
            case "normalReports":
                apiUrl = "/api/portal/report/";
                break;
            case "adminReports":
                // get the roleID of the super admin role
                const superAdminRoleID = getRoleID("superadmin");
                if (superAdminRoleID) {
                    // grab just the admin reports
                    apiUrl = "/api/portal/admin/report/";
                }
                else {
                    this.props.errorAlert("m0370")
                    return;
                }
                break;

            default:
                break;
        }
        switch (endpointSlug) {
            case "agedinventory":
                builder.append("uiLanguage", this.props.uiLanguage);
                builder.append("autoFilterType", endpointSlug);
                endpointSlug = "slowmovingitems";
                break;
            case "obsoleteinventory":
                builder.append("autoFilterType", endpointSlug);
                endpointSlug = "slowmovingitems";
                break;
            case "inventorymixcomparison":
                endpointSlug = "inventorymixbreakdown";
                break;
            default:
                break;
        }
        apiUrl = `${apiUrl}${endpointSlug}${builder.queryString}`;
        this.props.callApi(apiUrl);
    };

    // gets an array of all the filters to show for the user's orgtype and chosen report
    getFilterFields = () => {
        const orgType = this.context.state.orgType;
        const reportType = this.props.reportType;
        const filters = config.reportFilters[orgType][reportType];
        if (isEmpty(filters)) return;

        // a container for all the filters
        let filterControls = [];
        let filterControlProps = {};

        // build out an array containing all the filter controls
        filters.forEach((filter, index) => {
            // figure out what props to add to each filter control
            filterControlProps = {};
            if (filter.required) {
                filterControlProps.required = true;
            }
            if ('hasEmptyOption' in filter) {
                if (filter.hasEmptyOption === false)
                    filterControlProps.hasEmptyOption = false;
            }
            if (filter.filterType) {
                filterControlProps.filterType = filter.filterType;
            }
            if (filter.majorVendor) {
                filterControlProps.majorVendor = filter.majorVendor;
            }
            if (filter.dealerGroupOnly) {
                filterControlProps.dealerGroupOnly = filter.dealerGroupOnly;
            }


            switch (filter.filter) {
                case "ValueFilter":
                    filterControls.push(
                        <ValueFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                            mode={filter.mode}
                        />
                    );
                    break;
                case "AgeFilter":
                    filterControls.push(
                        <AgeFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "PartCategoryFilter":
                    filterControls.push(
                        <PartCategoryFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "PartGroupFilter":
                    filterControls.push(
                        <PartGroupFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "OrderTypeFilter":
                    filterControls.push(
                        <OrderTypeFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "PartNumberFilter":
                    filterControls.push(
                        <PartNumberFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "ExceptionFilter":
                    filterControls.push(
                        <ExceptionFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "CountryFilter":
                    filterControls.push(
                        <CountryFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "OrgTypeFilter":
                    filterControls.push(
                        <OrgTypeFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "OrgFilter":
                    filterControls.push(
                        <OrgFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "MonthYearFilter":
                    filterControls.push(
                        <MonthYearFilterLocalized
                            handleChange={this.handleChange}
                            key={index}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "DateFilter":
                    filterControls.push(
                        <DateFilterLocalized
                            key={index}
                            handleChange={this.handleChange}
                            handleClearDate={this.handleClearDate}
                            startDate={
                                this.context.state.selectedReportStartDate
                                    ? moment(this.context.state.selectedReportStartDate).format(
                                        "YYYYMMDD"
                                    )
                                    : null
                            }
                            endDate={this.context.state.selectedReportEndDate
                                ? moment(this.context.state.selectedReportEndDate).format(
                                    "YYYYMMDD"
                                )
                                : null}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "VendorFilter":
                    filterControls.push(
                        <VendorFilterLocalized
                            key={index}
                            handleChange={this.handleChange}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "DealershipFilter":
                    filterControls.push(
                        <DealershipFilterLocalized
                            key={index}
                            handleChange={this.handleChange}
                            {...filterControlProps}
                        />
                    );
                    break;
                case "CostFilter":
                    filterControls.push(
                        <CostFilterLocalized
                            key={index}
                            handleChange={this.handleChange}
                            mode={filter.mode}
                        />
                    )
                    break;
                default:
                    break;
            }
        });

        this.setState({ filterControls: filterControls });
    }
    render() {

        //!DBTRANS! @m0475@ Part Group: !DEVNOTE! Field label
        //!DBTRANS! @m0143@ Part Number:%space% !DEVNOTE! Field label
        //!DBTRANS! @m0470@ Exception: !DEVNOTE! Field label
        //!DBTRANS! @m0471@ Country: !DEVNOTE!Field label
        //!DBTRANS! @m0472@ Org Type: !DEVNOTE! Field label
        //!DBTRANS! @m0473@ Org: !DEVNOTE! Field label
        //!DBTRANS! @m0474@ Period: !DEVNOTE! Field label
        //!DBTRANS! @m0259@ Vendor !DEVNOTE! Input field label 
        //!DBTRANS! @m0020@ Choose a period !DEVNOTE! Dropdown Label
        //!DBTRANS! @m0019@ Choose a vendor !DEVNOTE! Dropdown Label
        //!DBTRANS! @m0476@ Dealership: !DEVNOTE! Field label
        //!DBTRANS! @m0477@ Report Group: !DEVNOTE! Field label
        //!DBTRANS! @m0478@ Select a dealership !DEVNOTE! Field label
        //!DBTRANS! @m0479@ Start Date: !DEVNOTE! Field label
        //!DBTRANS! @m0480@ End Date: !DEVNOTE! Field label
        //!DBTRANS! @m0481@ Start Date !DEVNOTE! Field label
        //!DBTRANS! @m0482@ End Date !DEVNOTE! Field label
        //!DBTRANS! @m0483@ You must select the part group filter! !DEVNOTE! Action status reason
        //!DBTRANS! @m0484@ You must select the order type filter! !DEVNOTE! Action status reason
        //!DBTRANS! @m0485@ You must type in the part number! !DEVNOTE! Action status reason
        //!DBTRANS! @m0486@ You must select the exception filter! !DEVNOTE! Action status reason
        //!DBTRANS! @m0487@ You must select the country filter! !DEVNOTE! Action status reason
        //!DBTRANS! @m0488@ You must select the org type filter! !DEVNOTE! Action status reason
        //!DBTRANS! @m0489@ You must select the org filter! !DEVNOTE! Action status reason
        //!DBTRANS! @m0490@ You must select the period filter! !DEVNOTE! Action status reason
        //!DBTRANS! @m0491@ You must specify a start date! !DEVNOTE! Action status reason
        //!DBTRANS! @m0492@ The end date must come after the start date! !DEVNOTE! Action status reason
        //!DBTRANS! @m0493@ You must choose a vendor! !DEVNOTE! Action status reason
        //!DBTRANS! @m0494@ You must choose either a dealership or report group! !DEVNOTE! Action status reason
        //!DBTRANS! @m0495@ You must select a dealership! !DEVNOTE! Action status reason
        //!DBTRANS! @m0496@ You must select a report group! !DEVNOTE! Action status reason
        //!DBTRANS! @m0370@ Unable to retrieve list of admin report url. !DEVNOTE! Action status
        //!DBTRANS! @m0606@ All Categories !DEVNOTE! Dropdown default
        //!DBTRANS! @m0607@ Part Category: !DEVNOTE! Dropdown label

        return (
            <form className="shadow-box report-search-panel">
                <div className="search-controls-header">{this.props.returnLocalizedString("m0466")}</div>
                {!this.props.disabled && this.state.filterControls}
                {this.props.disabled && this.props.disabledSettings}
                <Button primary={true} onClick={this.applyFilter} disabled={this.props.disabled}>
                    {this.props.returnLocalizedString("m0021")}
                </Button>
            </form>
        );
    }
}
export default isPage(ReportsDataFilters);

// here, we hardocde the tag name of each component.
// this way, when the app is bundled up during the build process, the tag names won't get compressed.
// logic in this file involves looking at the tag name of each of these components, so without doing the stuff below, that logic will break.
DealershipFilterLocalized.displayName = "DealershipFilter";
VendorFilterLocalized.displayName = "VendorFilter";
DateFilterLocalized.displayName = "DateFilter";
PartCategoryFilterLocalized.displayName = "PartCategoryFilter";
PartGroupFilterLocalized.displayName = "PartGroupFilter";
OrderTypeFilterLocalized.displayName = "OrderTypeFilter";
PartNumberFilterLocalized.displayName = "PartNumberFilter";
ExceptionFilterLocalized.displayName = "ExceptionFilter";
CountryFilterLocalized.displayName = "CountryFilter";
OrgTypeFilterLocalized.displayName = "OrgTypeFilter";
OrgFilterLocalized.displayName = "OrgFilter";
MonthYearFilterLocalized.displayName = "MonthYearFilter";
CostFilterLocalized.displayName = "CostFilter";
AgeFilterLocalized.displayName = "AgeFilter";
ValueFilterLocalized.displayName = "ValueFilter";

DateFilter.contextType = AppContext;
ReportsDataFilters.contextType = AppContext;
DealershipFilter.contextType = AppContext;
VendorFilter.contextType = AppContext;
PartCategoryFilter.contextType = AppContext;
PartGroupFilter.contextType = AppContext;
OrderTypeFilter.contextType = AppContext;
PartNumberFilter.contextType = AppContext;
ExceptionFilter.contextType = AppContext;
CountryFilter.contextType = AppContext;
OrgTypeFilter.contextType = AppContext;
OrgFilter.contextType = AppContext;
MonthYearFilter.contextType = AppContext;
CostFilter.contextType = AppContext;
AgeFilter.contextType = AppContext;
ValueFilter.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/components/ReportsDataFilters.js